// src/AnimatedRoutes.js
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const AnimatedRoutes = ({ children, ...props }) => {
  const [prevLocation, setPrevLocation] = useState(null);
  const [currentLocation, setCurrentLocation] = useState(null);
  const location = useLocation();

  const routesOrder = [
    "/",
    "/about",
    "/mytimeline",
    "/worksample",
    'ProfPartOfMeEducation'
    // ...其他路由路径
  ];

  const getCurrentIndex = (pathname) => {
    return routesOrder.findIndex((route) => route === pathname);
  };

  const isMovingForward = getCurrentIndex(prevLocation?.pathname) < getCurrentIndex(currentLocation?.pathname);

  useEffect(() => {
    setPrevLocation(currentLocation);
    setCurrentLocation(location);
  }, [location]);

  return (
    <div
      className={`route-transition ${isMovingForward ? 'forward' : 'backward'}`}
      {...props}
    >
      {children}
    </div>
  );
};
